import { render, staticRenderFns } from "./CollapseDivMain.vue?vue&type=template&id=201548dc"
import script from "./CollapseDivMain.vue?vue&type=script&lang=js"
export * from "./CollapseDivMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports